import { mapState, mapActions } from '@/store/helpers';

import { mapState as rootMapState } from 'pinia';
import {  usePageStore } from '@/store';

import * as TYPES from './_store/types';

import { buildUrl } from '@/router/index.js';


export default {
    i18next: {
        ns: 'md-search-result'
    },
    computed: {
        ...mapState({
            "layout": store => store.layout,
            "layoutOptions": store => store.layoutOptions,
            "mapType": store => store.mapType
        }),
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        showInsightGo() {
            return this.layout !== 'map' && !(this.layoutOptions.length === 1 && this.layoutOptions[0] === 'normal');
        }
    },
    props: ['breadCrumbs', 'isShowEmpty', 'showMap', 'snapshotLink'],
    methods: {
        ...mapActions({
            "updateUrl": TYPES.UPDATE_URL,
            "layoutUpdateMutation": TYPES.LAYOUT_UPDATE_MUTATION,
            "prevViewPatternMutation": TYPES.PREV_VIEW_PATTERN_MUTATION,
            "setShowInsight": TYPES.SHOW_INSIGHT_UPDATE_MUTATION
        }),
        
        
        getUrl(crumb, index) {
            if (this.page['FEATURE_AREA_VERSION']) {
                return `/area/${this.breadCrumbs?.[1].name?.toLowerCase?.()}-${this.breadCrumbs?.[0]?.name}/listings`.replaceAll(' ', '-')
            }
            const subUrl = this.breadCrumbs
                .slice(1, index + 1)
                .map(item => item.name)
                .join(',');
            if (this.page.pageKey == "sold-listing") {
                return buildUrl({
                    name: 'sold-detail',
                    params: {
                        id: this.breadCrumbs[0].name,
                        address: subUrl
                    }
                }).replaceAll(' ', '-');
            } 
            return `/${this.breadCrumbs[0].name}/${subUrl}`.replaceAll(' ', '-');
        },
        insight() {
            let lastLayout = '';
            if (!this.isMobileSize && this.layout === 'normal') {
                lastLayout = 'normal';
                this.layoutUpdateMutation({
                    layout: 'mixed',
                    isMobile: false
                });
            }
            this.setShowInsight({ isShow: true, lastLayout });
            this.updateUrl();
        },
        goInsight() {
            console.log('this.snapshotLink ===>>>', this.snapshotLink)
            if (this.snapshotLink) {
                window.open(this.snapshotLink)
            }
        }
    }
};
